import { Observable, Subscription } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { WebsocketClient } from '../../common/service/websocket-client.service';
import { AdditionalInfoImpl } from '../model/status/additional-info-impl';
import { WEBSOCKET_TOPIC_STATUSES_BY_SIDE_NUMBER } from '../../common/const';
import { MutatorFieldsCollection, parseStatusesWithMutatorCollection } from '../util/data-parser';
import { DataLoader } from 'src/app/shared/util/data-loader';
import { StoreService } from 'src/app/store/service/store.service';
import { Injectable } from '@angular/core';
import { StoreContent } from 'src/app/store/model/store-model';
import { DataSource } from 'src/app/shared/model/data-source';
import { DataSourceCollection } from 'src/app/shared/model/data-source-collection';
import { SortBy } from 'src/app/shared/model/data-source';
import { RequestCriteria } from 'src/app/shared/model/request-criteria';
import { applyCriteriaAndSorters } from 'src/app/shared/util/data-util';
import { VehicleLayout } from '../model/vehicle-layout';
import { VehicleDeviceLocation } from '../model/vehicle-device-location';
import { Device } from '../model/device';

@Injectable()
export class VehicleDevicesService implements DataLoader<AdditionalInfoImpl> {

  private sideNumber: string;
  private storeName: string;
  private mutatorFieldsCollection: MutatorFieldsCollection;
  private statusesSubscriptions: Subscription;
  private layout: VehicleLayout;

  constructor(private websocket: WebsocketClient, private storeService: StoreService) { }

  subscribeData(): void {
    if (!this.storeService.isStorageTypeExists(this.storeName)) {
      this.storeService.addStorageType(this.storeName, new StoreContent<AdditionalInfoImpl>((data: AdditionalInfoImpl) => ({ devId: data.device.devId })));
    }

    this.statusesSubscriptions = this.websocket.subscribe(`${WEBSOCKET_TOPIC_STATUSES_BY_SIDE_NUMBER}${this.sideNumber}`)
      .pipe(map((response: Array<AdditionalInfoImpl>) => {
        if (this.layout) {
          response.map((status: AdditionalInfoImpl) => {
            const location = this.layout.deviceLocations
              .find((loc: VehicleDeviceLocation) => loc.devices.map((dev: Device) => dev.devId).includes(status.device.devId));
            if (location) {
              status.hasLocation = true;
            }
          });
        }
        return parseStatusesWithMutatorCollection(response, this.mutatorFieldsCollection);
      }))
      .subscribe(statuses => this.storeService.store(this.storeName, statuses));
  }

  unsubscribeData(): void {
    this.statusesSubscriptions?.unsubscribe();
    this.websocket.unsubscribe(`${WEBSOCKET_TOPIC_STATUSES_BY_SIDE_NUMBER}${this.sideNumber}`);
    this.storeService.removeStorage(this.storeName);
  }

  getDataType(): any {
    return this.storeName;
  }

  setSideNumber(sideNumber: string): void {
    this.sideNumber = sideNumber;
  }

  setMainDataSource(dataSource: DataSource): void {
    this.storeName = dataSource.name;
  }

  setStatusesDataSourcesCollection(dataSourceCollection: DataSourceCollection): void {
    const mutatorFieldsCollection: MutatorFieldsCollection = {};
    Object.keys(dataSourceCollection).forEach(key => mutatorFieldsCollection[key] = dataSourceCollection[key].getMutatorFields());
    this.mutatorFieldsCollection = mutatorFieldsCollection;
  }

  fetchAll(filters: RequestCriteria, sorters?: SortBy[]): Observable<AdditionalInfoImpl[]> {
    return this.storeService.connectToAllDataUpdates<AdditionalInfoImpl>(this.storeName)
      .pipe(first(), map(data => applyCriteriaAndSorters(data, filters, sorters)));
  }

  setVehicleLayout(layout: VehicleLayout): void {
    this.layout = layout;
  }
}
